// lineFixedVertexTools.js — Sequential collectors for LINE fixed-vertex rules with mil-sym
// live preview (drawrule-arrow-order tickets 05, 10–12, 17–21).
// LINE3, LINE6, LINE11, LINE16, LINE26, LINE27, LINE31, LINE32, LINE50
//
// Library point order is click order (identity) — including LINE32 where tip is P3 (last click).
// LINE29/LINE30 live in tipAtP1ArrowTools.js (tip@P1 reverse).

import { DrawRules } from '@armyc2.c5isr.renderer/mil-sym-ts-web';
import Feature from 'ol/Feature';
import { LineString } from 'ol/geom';
import { registerDrawInteraction } from '../customDrawInteractions';
import { createSequentialCollector } from './sequentialCollector';
import { PREVIEW_LINE_BLUE } from './drawPreviewStyles';

function makeSequentialFixed(map, opts, { minCount, maxCount = minCount }) {
    return createSequentialCollector(map, {
        minCount,
        maxCount,
        onFinish: opts.onFinish,
        sidc: opts.sidc || null,
        previewMinPoints: Math.max(1, minCount - 1),
        cursorFirst: false,
        applyReorderToPreview: false,
        roleForIndex: (i) => (i === 0 ? 'anchor' : 'direction'),
        styleResolver: () => PREVIEW_LINE_BLUE,
        onSketchUpdate: ({ previewSource, collected3857, cursorCoord3857 }) => {
            const pts = cursorCoord3857 ? [...collected3857, cursorCoord3857] : collected3857;
            if (pts.length >= 2) previewSource.addFeature(new Feature(new LineString(pts)));
        },
    });
}

registerDrawInteraction(DrawRules.LINE3,  (map, opts) => makeSequentialFixed(map, opts, { minCount: 3 }));
registerDrawInteraction(DrawRules.LINE6,  (map, opts) => makeSequentialFixed(map, opts, { minCount: 3 }));
registerDrawInteraction(DrawRules.LINE11, (map, opts) => makeSequentialFixed(map, opts, { minCount: 4 }));
registerDrawInteraction(DrawRules.LINE16, (map, opts) => makeSequentialFixed(map, opts, { minCount: 4 }));
registerDrawInteraction(DrawRules.LINE26, (map, opts) => makeSequentialFixed(map, opts, { minCount: 3, maxCount: 4 }));
registerDrawInteraction(DrawRules.LINE27, (map, opts) => makeSequentialFixed(map, opts, { minCount: 3, maxCount: 4 }));
registerDrawInteraction(DrawRules.LINE31, (map, opts) => makeSequentialFixed(map, opts, { minCount: 4 }));
registerDrawInteraction(DrawRules.LINE32, (map, opts) => makeSequentialFixed(map, opts, { minCount: 3 }));
// LINE50 = 350 (hardcoded constant, not on DrawRules enum)
registerDrawInteraction(350, (map, opts) => makeSequentialFixed(map, opts, { minCount: 3 }));
